module.exports = __webpack_public_path__ + "assets/img/workLeft3.c972a91e.png";